import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../assets/css/CompanySelectorModal.css";

const CompanySelectorModal = ({
  show,
  onHide,
  onContinue,
  companies,
  setEmployeeId = () => {},
  setWorkLocation = () => {},
}) => {
  const [selectedCompany, setSelectedCompany] = useState(null);

  const handleSelectCompany = (company) => {
    setSelectedCompany(company);
    setEmployeeId(company.employee_id);
  };

  const currentCompany = localStorage.getItem("companyName");

  const handleContinue = () => {
    if (selectedCompany) {
      const workLocation = selectedCompany?.work_location;
      const companyURL = selectedCompany?.company_name
        ?.trim()
        ?.replace(/\s+/g, "-")
        .toLowerCase();
      localStorage.setItem("company_url", companyURL);
      localStorage.setItem("work_location", workLocation);
      setWorkLocation(workLocation);
      onContinue(selectedCompany);
      onHide();
    }
  };

  return (
    <Modal
      show={show}
      centered
      animation
      size="lg"
      className="company-selector-modal"
    >
      <Modal.Header>
        <Modal.Title>Select a Company</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-2">
          {companies
            ?.filter((company) => company?.company_name !== currentCompany)
            .map((company) => (
              <div
                key={company?.company_id}
                className={`company-item ${
                  selectedCompany &&
                  selectedCompany?.company_id === company?.company_id
                    ? "selected"
                    : ""
                }`}
                onClick={() => handleSelectCompany(company)}
              >
                <span>{company?.company_name}</span>
              </div>
            ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-cancel" onClick={onHide}>
          Cancel
        </Button>
        <Button
          className="btn-continue"
          onClick={handleContinue}
          disabled={!selectedCompany}
        >
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CompanySelectorModal;
